/**
 * 友盟 U-Web（网站统计）埋点封装
 * 使用 _czc.push(['_trackEvent', ...])，无需后台预先创建自定义事件。
 * 文档：https://developer.umeng.com/docs/67963/detail/2392290
 * 站点 ID：1281500510（index.html 全局引入）
 */

/** 网站统计站点 ID */
export const UMENG_SITE_ID = '1281500510'

/** 首页「血压自测趋势分析」点击 */
export const EVENT_HOME_BP_TREND_CLICK = {
  category: '首页',
  action: '血压自测趋势分析点击',
  label: '健康首页'
}

/** 首页「智能健康自查」点击 */
export const EVENT_HOME_SMART_CHECK_CLICK = {
  category: '首页',
  action: '智能健康自查点击',
  label: '健康首页'
}

/** 医学报告解读页「开始解读」点击 */
export const EVENT_REPORT_START_CLICK = {
  category: '医学报告解读',
  action: '开始解读',
  label: 'report-upload'
}

/** 心血管疾病筛查页「开始评估」点击 */
export const EVENT_SYMPTOM_START_CLICK = {
  category: '心血管疾病筛查',
  action: '开始评估',
  label: 'symptom-select'
}

/** 心脏友好饮食页「开始分析」点击 */
export const EVENT_DIET_START_CLICK = {
  category: '心脏友好饮食',
  action: '开始分析',
  label: 'diet-assistant'
}

/** 中医体质辨识「生成体质报告」点击 */
export const EVENT_TCM_REPORT_CLICK = {
  category: '中医体质辨识',
  action: '生成体质报告',
  label: 'tcm-questionnaire'
}

/** 血压自测趋势页「血压打卡」确定成功 */
export const EVENT_BP_CHECKIN_SUCCESS = {
  category: '血压自测趋势分析',
  action: '血压打卡确定成功',
  label: 'bp-checkin'
}

/**
 * 获取 _czc 指令队列
 * @returns {Array|null}
 */
function getCzcQueue() {
  if (typeof window === 'undefined') return null
  window._czc = window._czc || []
  return window._czc
}

/**
 * 事件跟踪（_trackEvent）
 * @param {string} category 事件类别（必填）
 * @param {string} action 事件操作（必填）
 * @param {string} [label] 事件标签（选填）
 * @param {number} [value] 事件值（选填，整数）
 * @returns {void}
 */
export function trackEvent(category, action, label, value) {
  if (!category || !action) {
    console.warn('[umeng] _trackEvent 缺少 category 或 action')
    return
  }
  const queue = getCzcQueue()
  if (!queue) return

  /** @type {Array<*>} */
  const args = ['_trackEvent', category, action]
  if (label !== undefined && label !== null && label !== '') {
    args.push(String(label))
  }
  if (value !== undefined && value !== null && !isNaN(Number(value))) {
    if (args.length === 3) args.push('')
    args.push(parseInt(String(value), 10) || 0)
  }
  queue.push(args)
  // z.js 只在首屏加载一次；点击走 _czc 队列，实际上报域名通常不是 z.js
  var sdkReady = typeof queue.push === 'function' && !Array.isArray(queue)
  console.log('[umeng] _trackEvent', args, {
    sdkReady: sdkReady || (window._czc && typeof window._czc.push === 'function'),
    tip: '点击不会再次请求 z.js，请在 Network 筛 cnzz / icon / gif 查看上报'
  })
}

/**
 * 点击埋点
 * @param {string|{category:string,action:string,label?:string,value?:number}} eventOrCode
 * @param {Object} [params]
 * @returns {void}
 */
export function trackClick(eventOrCode, params) {
  if (!eventOrCode) return
  if (typeof eventOrCode === 'object') {
    trackEvent(eventOrCode.category, eventOrCode.action, eventOrCode.label, eventOrCode.value)
    return
  }
  trackEvent('首页', String(eventOrCode), (params && params.entry) || '')
}

/**
 * SPA 手动发送页面 PV
 * @param {string} [path]
 * @returns {void}
 */
export function trackPageView(path) {
  const queue = getCzcQueue()
  if (!queue) return
  let page = path
  if (!page && typeof window !== 'undefined') {
    page = window.location.pathname + (window.location.hash || '') + (window.location.search || '')
  }
  queue.push(['_trackPageview', page || '/'])
}



// WEBPACK FOOTER //
// ./src/utils/umeng.js